import {Injectable} from "@angular/core";
import {ClickkerHttpClient} from "./ClickkerHttpClient";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export abstract class AuthHttpClient extends ClickkerHttpClient {
    constructor() {
        super(environment.clickkerAuth.api.url)
    }
}
